(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-nip-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  function initNipPopup() {
    var dialog = document.getElementById('cart-nip-popup');
    if (!dialog) return;

    var resolved = false;

    function showStep(name) {
      dialog.querySelectorAll('[data-nip-popup-step]').forEach(function (step) {
        step.hidden = step.getAttribute('data-nip-popup-step') !== name;
      });
    }

    function proceedToCheckout() {
      resolved = true;
      dialog.close();
      var checkoutBtn = document.getElementById('checkout');
      if (checkoutBtn) checkoutBtn.click();
    }

    // Single delegated listener (capture phase) so it keeps working even if
    // the cart drawer/page content is morphed or re-rendered after a cart
    // update, without needing to re-bind to specific nodes.
    document.addEventListener(
      'click',
      function (event) {
        if (event.target.closest('#checkout')) {
          if (resolved) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          showStep('choice');
          dialog.showModal();
          return;
        }

        if (event.target.closest('[data-nip-popup-private]')) {
          proceedToCheckout();
          return;
        }

        if (event.target.closest('[data-nip-popup-company]')) {
          showStep('company');
          return;
        }

        if (event.target.closest('[data-nip-popup-back]')) {
          showStep('choice');
          return;
        }

        if (event.target.closest('[data-nip-popup-continue]')) {
          var nip = document.getElementById('cart-nip');
          if (nip && !nip.checkValidity()) {
            nip.reportValidity();
            return;
          }
          proceedToCheckout();
          return;
        }

        if (event.target.closest('[data-nip-popup-close]')) {
          dialog.close();
        }
      },
      true
    );

    dialog.addEventListener('close', function () {
      if (!resolved) showStep('choice');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNipPopup);
  } else {
    initNipPopup();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    (function () {
  function bindNipRequirement() {
    const company = document.getElementById('cart-company');
    const nip = document.getElementById('cart-nip');
    if (!company || !nip) return;

    function sync() {
      nip.required = company.value.trim().length > 0;
    }

    sync();
    company.addEventListener('input', sync);

    // Persist directly to cart.attributes via Cart API, independent of
    // however the checkout button itself is handled (app widgets etc.
    // intercept that click and don't reliably submit this native form).
    // keepalive ensures the request survives the page navigating away to
    // checkout right after the user clicks (fixes data loss when the
    // browser cancels an in-flight fetch on navigation).
    function saveAttributes() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          attributes: {
            Company: company.value,
            NIP: nip.value
          }
        })
      });
    }

    let saveTimer = null;
    function scheduleSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveAttributes, 400);
    }

    company.addEventListener('input', scheduleSave);
    nip.addEventListener('input', scheduleSave);
    company.addEventListener('change', saveAttributes);
    nip.addEventListener('change', saveAttributes);

    // Final safety net: flush immediately before the cart form submits,
    // so values typed right before clicking checkout aren't lost to the
    // debounce delay or to an express-checkout button that navigates fast.
    const cartForm = document.getElementById('cart-form');
    if (cartForm) {
      cartForm.addEventListener(
        'submit',
        function () {
          clearTimeout(saveTimer);
          saveAttributes();
        },
        { capture: true }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindNipRequirement);
  } else {
    bindNipRequirement();
  }
})();

/* (function () {
  function bindNipRequirement() {
    const company = document.getElementById('cart-company');
    const nip = document.getElementById('cart-nip');
    if (!company || !nip) return;

    function sync() {
      nip.required = company.value.trim().length > 0;
    }

    sync();
    company.addEventListener('input', sync);

    // Persist directly to cart.attributes via Cart API, independent of
    // however the checkout button itself is handled (app widgets etc.
    // intercept that click and don't reliably submit this native form).
    function saveAttributes() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            Company: company.value,
            NIP: nip.value
          }
        })
      });
    }

    company.addEventListener('change', saveAttributes);
    nip.addEventListener('change', saveAttributes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindNipRequirement);
  } else {
    bindNipRequirement();
  }
})(); */
  } catch(e) { console.error(e); }
})();

})();
